import React, { useEffect, useState } from 'react'
import { IActivityDetail } from './IActivityDetail'
import { useGetTokenUri } from '../../../../../hooks/useNFTMarketPlace'
import { useGetBaseUri } from '../../../../../hooks/useYetiSwapNFTCollection'
import Api from '../../../../../services/Api'
import { IDefaultCard } from '../Card/IDefaultCard'
import DefaultCardImage from '../components/DefaultCardImage/DefaultCardImage'
import BaseActivity from '../../Base/Activity/BaseActivity'

export default function ActivityDetail({ collection, historyItem, chainId }: IActivityDetail) {
  const { tokenId } = historyItem
  const tokenUri = useGetTokenUri(collection.tokenAddress, tokenId)
  const [tokenItem, setTokenItem] = useState<IDefaultCard | null>(null)
  const nftBaseUri = useGetBaseUri()
  const tokenName = tokenItem ? tokenItem.name : 'Token Name'

  useEffect(() => {
    if (tokenUri) {
      Api.get(tokenUri).then((tokenResult: any) => setTokenItem(tokenResult))
    }
  }, [tokenUri])

  return (
    <BaseActivity chainId={chainId} historyItem={historyItem} collection={collection} tokenName={tokenName}>
      <DefaultCardImage item={tokenItem} baseURI={nftBaseUri} isCard={true} />
    </BaseActivity>
  )
}
